// extracted by mini-css-extract-plugin
export var form = "_cy-0";